import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as candidatesActions from '@app/modules/candidates/store/candidates.actions';
import * as LayoutActions from '@layout/store/layout.actions';
import {
  assignCandidatesLoadSuccess,
  assignRejectedCandidatesLoadSuccess,
  setTotalNumberOfCandidatesAndProspects,
} from '@modules/assigns/store/assigns.actions';
import {
  jobCandidatesAdvancedLoadSuccess,
  jobCandidatesInReviewLoadSuccess,
  jobCandidatesRejectedLoadSuccess,
} from '@modules/job-page/store/hiring-manager';
import {
  collectionCandidatesClear,
  jobCandidatesLoad,
  jobCandidatesLoadSuccess,
} from '@modules/job-page/store/job.actions';
import { Candidate, candidateParser, candidatesParser } from '@shared/models/candidate';

import {
  candidatesGetSuccess,
  candidatesSelect,
  candidatesUpdateSuccess,
} from './candidates.actions';
import { selectCandidateForSideDrawerSuccess } from '@shared/candidate/side-nav-candidate/store/candidate-side-nav.actions';
import { createReducer, on } from '@ngrx/store';

export interface CandidatesState extends EntityState<Candidate> {
  selectedId?: number;
  loaded: boolean;
  isUpdated: boolean;
  totalCandidatesShortlist: TotalShortlistCandidate;
}

export interface TotalShortlistCandidate {
  totalAllCandidates: number;
  totalProspects: number;
}

export const candidatesAdapter: EntityAdapter<Candidate> = createEntityAdapter<Candidate>({
  selectId: (candidate: Candidate) => candidate.id,
  sortComparer: false,
});

export const initialState: CandidatesState = candidatesAdapter.getInitialState({
  selectedId: 0,
  loaded: false,
  isUpdated: false,
  totalCandidatesShortlist: {
    totalAllCandidates: 0,
    totalProspects: 0,
  },
});

export const candidatesReducer = createReducer(
  initialState,
  on(jobCandidatesLoad, candidatesActions.candidatesLoad, (state) => ({
    ...state,
    loaded: false,
  })),
  on(jobCandidatesLoadSuccess, candidatesActions.candidatesLoadSuccess, (state, { payload }) =>
    candidatesAdapter.upsertMany(candidatesParser(payload.content), {
      ...state,
      loaded: true,
    }),
  ),
  on(collectionCandidatesClear, (state) => candidatesAdapter.removeAll({ ...state })),
  on(
    jobCandidatesInReviewLoadSuccess,
    jobCandidatesAdvancedLoadSuccess,
    jobCandidatesRejectedLoadSuccess,
    (state, { payload }) => {
      const candidates: Candidate[] = payload.candidates.content;
      return candidatesAdapter.upsertMany(candidatesParser(candidates), {
        ...state,
        loaded: true,
      });
    },
  ),
  on(
    assignCandidatesLoadSuccess,
    assignRejectedCandidatesLoadSuccess,
    LayoutActions.layoutHeaderLoadCandidatesSuccess,
    candidatesActions.candidatesSimilarLoadSuccess,
    (state, { payload }) => candidatesAdapter.upsertMany(candidatesParser(payload.content), state),
  ),
  on(candidatesGetSuccess, candidatesUpdateSuccess, (state, { payload }) =>
    candidatesAdapter.upsertOne(candidateParser(payload as any, false), state),
  ),
  on(candidatesSelect, selectCandidateForSideDrawerSuccess, (state, { id }) => ({
    ...state,
    selectedId: id,
  })),
  on(setTotalNumberOfCandidatesAndProspects, (state, { totalAllCandidates, totalProspects }) => ({
    ...state,
    totalCandidatesShortlist: {
      totalAllCandidates,
      totalProspects,
    },
  })),
);
